import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  host: {
    class: 'bg-light'
  }
})
export class SideNavComponent implements OnInit {

  constructor(public auth: AuthService) { }

  ngOnInit() {
  }

}
